import { Tag } from "antd";
import React from "react";

/**
 * HTag - A reusable tag component for displaying counts with "99+" overflow
 * @param {number} count - The count value to display
 * @param {boolean} show - Whether to show the tag (defaults to true if count > 0)
 * @param {string} className - Additional CSS classes
 * @param {string} dataCy - Data-cy attribute for testing
 * @param {number} maxDisplay - Maximum number to display before showing "99+" (default: 99)
 */
const HTag = ({ 
  count = 0, 
  show = null, 
  className = "", 
  "data-cy": dataCy = "hs-tag",
  maxDisplay = 99
}) => {
  // If show is explicitly provided, use it; otherwise show if count > 0
  const shouldShow = show !== null ? show : count > 0;

  if (!shouldShow) {
    return null;
  }

  const displayCount = count > maxDisplay ? `${maxDisplay}+` : count;

  return (
    <Tag 
      className={`text-white border-none ms-auto hs-border-9999-px ${className}`}
      data-cy={dataCy}
    >
      {displayCount}
    </Tag>
  );
};

export default HTag;

